/**
 * 매장 목록 조회용 공용 GraphQL 문서.
 * home, admin 등 여러 도메인에서 재사용하므로 src/api에 둠.
 */
import { gql } from "@apollo/client";
import { STORE_INFO_FRAGMENT } from "./fragments";

export const GET_STORES = gql`
  query StoresV2($lat: Float, $lng: Float, $offset: Int, $limit: Int) {
    storesV2(lat: $lat, lng: $lng, offset: $offset, limit: $limit) {
      ...StoreInfo
    }
  }
  ${STORE_INFO_FRAGMENT}
`;
